import IEvent from "@/models/dto/IEvent";
import { EventTypeEnum } from "@/models/enum-types/event-type.enum";
import IDeviceStore from "@/models/modelStore/IDeviceStore";
import IAlert from "@/models/modelView/IAlert";
import devicesModule from "@/store/modules/devices.module";

export default abstract class EventStrategy {
    icon: EventTypeEnum
    event: IEvent
    title: string
    device?: IDeviceStore

    constructor(icon: EventTypeEnum, event: IEvent, title: string) {
        this.icon = icon;
        this.event = event;
        this.title = title;
        this.device = devicesModule.devices.find(device => device.id === event.deviceId)
    }

    abstract mapEvent(): IAlert

    eventBase() {
        return {
            id: this.event.id,
            device_icon: this.device?.icon || '0',
            icon: this.icon,
            latitude: this.event.latitude,
            longitude: this.event.longitude,
            plate: this.device?.name || '',
            time: this.event.eventTime || '', 
            title: this.title,
            type: this.icon
        }
    }
}